<template>
<div class="close">
    <div @click="close()">✖</div>
    <d-msg v-if="askclose"  title="Close"  text="Close current work?"  yesno  @close='confirmclose($event)' />
</div>
</template>

<script>
export default {
  props: {
      ask:Boolean
  },
  data () {
    return {
        askclose:false
    }
  },
  methods: {
    confirmclose(e) {
        this.askclose=false;
        if (e=="yes") {
            this.$emit('close');            
        }
    },
    close() {
          if (this.ask) {
              this.askclose=true;
          } else {
            this.$emit('close');
          }
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/_eng/globals/dclose.vue